import { AuthProvider } from "./AuthContext";
import { ConnectionProvider } from "./ConnectionContext";
import { combineComponents } from "./combine";
import { InviteProvider } from "./InviteContext";
import { ProjectProvider } from "./ProjectContext";
import { PropertyProvider } from "./PropertyContext";
import { VaultProvider } from "./VaultContext";
import { BusinessProvider } from "./BusinessContext";
import { GroupProvider } from "./GroupContext";
import { PostProvider } from "./PostContext";

const providers = [
    AuthProvider, InviteProvider, 
    PropertyProvider, VaultProvider, 
    ProjectProvider, 
    ConnectionProvider, BusinessProvider, 
    GroupProvider, PostProvider
];
export const AppContextProvider = combineComponents(...providers);
